import { ContentType } from '@insided/shared/utils/contentType'
import axios from 'axios'

export async function reportTopic(userId: number, reason: string, contentType?: ContentType, topicId?: number) {
  return await axios.post(`/community/api/${contentType}s/${topicId}/report`, {
    reason: reason
  }, { params: { reportedBy: userId } })
}

export async function reportReply(userId: number, reason: string, contentType?: ContentType, replyId?: number) {
  return await axios.post(`/community/api/${contentType}s/replies/${replyId}/report`, {
    reason: reason
  }, { params: { reportedBy: userId } })
}
